import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { IDataSolicitudFallido, IDataSolicitudSupercion } from "../interfaces/erp/supervision/supervision.interface"
import { EstadoComponente } from "../components/ui";
import { calcColorStatusGeneral, calcTrazavilidadToString, cellEstadoVentaSupervisor, cellNotFilter, formatDateWithTimeAMPM } from "../utils";
import { TrazabilidadAccionChoiceEnum } from "../constants";
import InfoUser from "../components/ui/InfoUser/InfoUser";
import { ISolicitudDesbloqueoCorporativo } from "../interfaces/erp/supervision/solicitud_nueva_linea_corporativo";

interface UseTableColumnsSolicitudLiberacionProps {
  estado_solicitud: string
}
export const useTableColumnsSolicitudLiberacion = ({

}: UseTableColumnsSolicitudLiberacionProps) => {



  const columnBase = useMemo<MRT_ColumnDef<IDataSolicitudSupercion>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación Cliente',
      size: 200
    },
    {
      accessorKey: 'cliente_razon_social',
      header: 'Nombre Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.razon_social : 'N/A'
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha',
      header: 'Fecha de registro',
      enableColumnFilter: false,
      enableSorting: false,
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(cellEstadoVentaSupervisor(row.original).fecha_registro)
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'estado',
      header: 'Estado Solicitud',
      size: 150,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.estado != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
            texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_flujo',
      header: 'Estado Venta',
      size: 200,
      Cell: ({ row }) => (
        <EstadoComponente backgroundColor={'blue'} texto={cellEstadoVentaSupervisor(row.original).modulo || ''} />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.segmentacion',
      header: 'Segmentacion',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score',
      header: 'score',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_empresa',
      header: 'score empresa',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_sobreendeudamiento',
      header: 'score sobreendeudamiento',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Solicito',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={calcTrazavilidadToString(row.original.trazo_venta_data, TrazabilidadAccionChoiceEnum.CREACION)} />
      },
    },
  ], []);

  const columnBaseLiberacionProspecto = useMemo<MRT_ColumnDef<IDataSolicitudFallido>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificación Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.identificacion : 'N/A'
      ),
    },
    {
      accessorKey: 'razon_social',
      header: 'Nombre Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data != null ? row.original.prospecto_data.razon_social : 'N/A'
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha de registro',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.prospecto_data.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado',
      header: 'Estado Solicitud',
      size: 150,
      Cell: ({ row }) => (
        row.original.estado != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
            texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.segmentacion',
      header: 'Segmentacion',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score',
      header: 'score',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_empresa',
      header: 'score empresa',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.puntaje_score_sobreendeudamiento',
      header: 'score sobreendeudamiento',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Solicito',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={row.original.user_create} />
      },
    },
  ], []);

  const columnSolicitudNuevaLineaCorporativo = useMemo<MRT_ColumnDef<ISolicitudDesbloqueoCorporativo>[]>(() => [

    {
      accessorKey: 'identificacion',
      header: 'Identificación Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_corporativo_data != null ? row.original.prospecto_corporativo_data.identificacion : 'N/A'
      ),
    },
    {
      accessorKey: 'razon_social',
      header: 'Nombre Cliente',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_corporativo_data != null ? row.original.prospecto_corporativo_data.razon_social : 'N/A'
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'prospecto_corporativo_data.segmentacion',
      header: 'Segmentacion',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_corporativo_data.puntaje_score',
      header: 'score',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_corporativo_data.puntaje_score_empresa',
      header: 'score empresa',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_corporativo_data.puntaje_score_sobreendeudamiento',
      header: 'score sobreendeudamiento',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha Solicitud',
      size: 200,
      Cell: ({ row }) => formatDateWithTimeAMPM(row.original.fecha_creacion)
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Solicito',
      size: 200,
      Cell: ({ row }) => {
        return <InfoUser user={row.original.user_create} />
      },
    },
  ], []);


  return {
    columnBase,
    columnBaseLiberacionProspecto,
    columnSolicitudNuevaLineaCorporativo
  }
}